import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d54559e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "teleporter-app-header",
  class: "header bg-white fixed top-0 left-0 right-0 z-20 shadow-black-20"
}
const _hoisted_2 = { class: "main-view mt-fixed-header mb-fixed-footer" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "footer fixed bottom-0 left-0 right-0 z-20 shadow-black-20" }, null, -1))

import NavBarCompany from "@/components/NavBarCompany.vue";
import NavBarStudent from "@/components/NavBarStudent.vue";
import { calculateMargins } from "@/helpers/calculateMargins";
import { ActionTypes as LoginActions } from "@/store/modules/login/action-types";
import { computed, onMounted, onUnmounted } from "vue";
import { useMeta } from "vue-meta";
import { useRoute, useRouter } from "vue-router";
import ImpersonateBar from "./components/ImpersonateBar.vue";
import NavBarPublic from "./components/NavBarPublic.vue";
import useImpersonator from "./helpers/useImpersonator";
import { Routes } from "./router";
import { useStore } from "./store";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useMeta({ title: "" });
const store = useStore();
const router = useRouter();
const route = useRoute();
const user = computed(() => store.getters["user"]);
const isStudent = computed(() => store.getters["isStudent"]);
const isCompany = computed(() => store.getters["isCompany"]);
const isUniversity = computed(() => store.getters["isUniversity"]);
const showNavbar = computed(() => !route.meta.hideNavigation);
const isPublic = computed(() => route.meta.public);
const navigation = computed(() => (isStudent.value ? NavBarStudent : NavBarCompany));
const { impersonator } = useImpersonator();

const handleLogoutClick = async () => {
  await store.dispatch(LoginActions.LOGOUT);
  router.push({ name: Routes.LOGIN });
};

onMounted(() => {
  window.addEventListener("resize", calculateMargins, true);
});

onUnmounted(() => {
  window.removeEventListener("resize", calculateMargins, true);
});

return (_ctx: any,_cache: any) => {
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_metainfo, null, {
      title: _withCtx(({ content }) => [
        _createTextVNode(_toDisplayString(content ? `${content} - MATCHD` : `MATCHD`), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass({
      'theme-student': isStudent.value,
      'theme-company': isCompany.value,
      'theme-university': isUniversity.value,
      'theme-public': !user.value && isPublic.value && showNavbar.value,
    })
    }, [
      _createElementVNode("header", _hoisted_1, [
        (showNavbar.value && user.value)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(navigation.value), {
              key: 0,
              user: user.value,
              onClickLogout: handleLogoutClick
            }, null, 40, ["user"]))
          : (showNavbar.value)
            ? (_openBlock(), _createBlock(NavBarPublic, { key: 1 }))
            : _createCommentVNode("", true),
        (_unref(impersonator))
          ? (_openBlock(), _createBlock(ImpersonateBar, { key: 2 }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ]),
      _hoisted_3
    ], 2)
  ], 64))
}
}

})